export const ROLES = {
  INSPECTION_COORDINATOR: "InspectionCoordinator",
  INSPECTION_DIRECTOR: "InspectionDirector",
  INSPECTION_PROSECUTOR: "InspectionProsecutor",
  INSPECTION_REGISTRAR: "InspectionRegistrar",

  REGIONAL_COUNCIL_OFFICE_HEAD: "RegionalOfficeOfCouncilHead",
  ZONAL_COUNCIL_OFFICE_HEAD: "ZonalOfficeOfCouncilHead",

  REGIONAL_COUNCIL_OFFICE_WRITER: "RegionalCouncilOfficeWriter",
  ZONAL_COUNCIL_OFFICE_WRITER: "ZonalCouncilOfficeWriter",

  // ADVOCATE_DISCIPLINE_PROSECUTOR: "AdvocateDisciplineProsecutor",
  // ADVOCATE_DISCIPLINE_COORDINATOR: "AdvocateDisciplineCoordinator",
  // REGIONAL_OFFENCE_OF_ADVOCATE_COUNCIL_WRITTER:
  //   "RegionalOfficeOfAdvocateCouncilWritter",
  // REGIONAL_OFFENCE_OF_ADVOCATE_COUNCIL_HEAD:
  //   "RegionalOfficeOfAdvocateCouncilHead",

  // ADVOCATE_DISCIPLINE_REGISTRAR: "AdvocateDisciplineRegistrar",
  // ADVOCATE_REGIONAL_OFFICE_OF_COUNCIL_COORDINATOR:
  //   "AdvocateRegionalOfficeOfCouncilCoordinator",
  // ADVOCATE_ZONAL_OFFICE_OF_COUNCIL_HEAD: "AdvocateZonalOfficeOfCouncilHead",
};

export const ADVOCATE_ROLES = {
  INSPECTION_COORDINATOR: "AdvocateDisciplineCoordinator",
  INSPECTION_DIRECTOR: "InspectionDirector",
  INSPECTION_PROSECUTOR: "AdvocateDisciplineProsecutor",
  INSPECTION_REGISTRAR: "AdvocateDisciplineRegistrar",
  REGIONAL_COUNCIL_OFFICE_HEAD: "RegionalOfficeOfAdvocateCouncilHead",
  REGIONAL_COUNCIL_OFFICE_WRITER: "RegionalOfficeOfAdvocateCouncilWritter",
  ADVOCATE_ZONAL_OFFICE_OF_COUNCIL_HEAD: "AdvocateZonalOfficeOfCouncilHead",
  ZONAL_COUNCIL_OFFICE_HEAD: "AdvocateZonalOfficeOfCouncilHead",
  ZONAL_COUNCIL_OFFICE_WRITER: "AdvocateZonalOfficeOfCouncilCoordinator",
  ZONAL_OFFICE_OF_COUNCIL_COORDINATOR:
    "AdvocateZonalOfficeOfCouncilCoordinator",
};
